<template>
  <v-content class="logo-page-container">
    <v-container fluid>
      <v-layout align-center justify-center column class="logo-container">
        <v-flex xs12 d-flex align-center justify-center>
          <img class="logo-image logo--shadow" src="@/assets/img/ruishishu.png" alt="">
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center>
        <slot></slot>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
.logo-page-container {
  overflow-y: auto;
  align-items: center;
  justify-content: center;
  display: flex;
}

.logo-container {
  height: 35vh;
}

.logo-image {
  max-height: 25vh;
}
</style>
